// import React, { useMemo } from "react";
// import { useTable, useSortBy, useFilters } from "react-table";
// import { Table, Form, InputGroup } from "react-bootstrap";
// import PropTypes from "prop-types";

// const DefaultColumnFilter = ({
//   column: { filterValue, setFilter, Header },
// }) => (
//   <InputGroup>
//     <Form.Control
//       placeholder={`Search ${Header}`}
//       value={filterValue || ""}
//       onChange={(e) => setFilter(e.target.value || undefined)}
//     />
//   </InputGroup>
// );

// DefaultColumnFilter.propTypes = {
//   column: PropTypes.shape({
//     filterValue: PropTypes.string,
//     setFilter: PropTypes.func.isRequired,
//     Header: PropTypes.string.isRequired,
//   }).isRequired,
// };

// const CustomGrid = ({ columns, data, smallTable }) => {

//   const defaultColumn = useMemo(
//     () => ({
//       Filter: DefaultColumnFilter,
//     }),
//     []
//   );

//   const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
//     useTable(
//       {
//         columns,
//         data,
//         defaultColumn,
//       },
//       useFilters, // Use filters hook
//       useSortBy // Use sorting hook
//     );

//   return (
//     // <div style={{ overflowX: 'auto', width:"100%"}} className="scrollbar-custom">
//     <div
//       className="custom-grid"
//       style={smallTable ? { maxHeight: "300px", overflowY: "auto" } : {}}
//     >
//       <Table
//         {...getTableProps()}
//         striped
//         bordered
//         hover
//         // responsive
//         className="custom-grid"
//       >
//         <thead>
//           {headerGroups.map((headerGroup, idx) => (
//             <tr key={idx} {...headerGroup.getHeaderGroupProps()}>
//               {headerGroup.headers.map((column, idx) => (
//                 <th
//                   key={idx}
//                   {...column.getHeaderProps(column.getSortByToggleProps())}
//                   style={{
//                     width: column.width,
//                     minWidth: column.minWidth || "10px", // Set minWidth
//                   }}
//                 >
//                   <div className="d-flex justify-content-between align-items-center">
//                     {column.render("Header")}
//                     <span>
//                       {column.isSorted
//                         ? column.isSortedDesc
//                           ? " 🔽"
//                           : " 🔼"
//                         : ""}
//                     </span>

//                     {/* <Button
//                       variant="outline-secondary"
//                       size="sm"
//                       onClick={() => toggleFilter(column.Header)}
//                       className="ml-2"
//                     >
//                       <FiMoreVertical />
//                     </Button> */}
//                   </div>
//                   {/* <div>
//                     {filterVisibility[column.Header] && column.canFilter
//                       ? column.render("Filter")
//                       : null}
//                   </div> */}
//                 </th>
//               ))}
//             </tr>
//           ))}
//         </thead>
//         <tbody {...getTableBodyProps()}>
//           {rows.map((row, idx) => {
//             prepareRow(row);
//             return (
//               <tr key={idx} {...row.getRowProps()}>
//                 {row.cells.map((cell, idx) => (
//                   <td
//                     key={idx}
//                     {...cell.getCellProps()}
//                     style={{ width: cell.column.width }}
//                   >
//                     {cell.render("Cell")}
//                   </td>
//                 ))}
//               </tr>
//             );
//           })}
//         </tbody>
//       </Table>
//     </div>
//   );
// };

// CustomGrid.propTypes = {
//   columns: PropTypes.arrayOf(
//     PropTypes.shape({
//       Header: PropTypes.string,
//       accessor: PropTypes.string,
//       Cell: PropTypes.func, // Cell is a function that returns JSX
//       width: PropTypes.string, // Define the width for the column
//       minWidth: PropTypes.string, // Define the minimum width for the column
//     })
//   ).isRequired,
//   data: PropTypes.any,
//   smallTable: PropTypes.any,
// };

// export default CustomGrid;




import React, { useMemo, useEffect } from "react";
import { useTable, useSortBy, useFilters, usePagination } from "react-table";
import { Table, Form, InputGroup, Pagination } from "react-bootstrap";
import PropTypes from "prop-types";

const DefaultColumnFilter = ({
  column: { filterValue, setFilter, Header },
}) => (
  <InputGroup>
    <Form.Control
      placeholder={`Search ${Header}`}
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
    />
  </InputGroup>
);

DefaultColumnFilter.propTypes = {
  column: PropTypes.shape({
    filterValue: PropTypes.string,
    setFilter: PropTypes.func.isRequired,
    Header: PropTypes.string.isRequired,
  }).isRequired,
};

const CustomGrid = ({
  columns,
  data,
  pageSize = 50,
  count = 0,
  currentPage = 0,
  onPageChange,
  onPageSizeChange,
}) => {
  const defaultColumn = useMemo(() => ({ Filter: DefaultColumnFilter }), []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      initialState: { pageIndex: currentPage, pageSize },
      manualPagination: true, // enable server-side style pagination
      pageCount: Math.ceil(count / pageSize),
    },
    useFilters,
    useSortBy,
    usePagination
  );

  // Sync react-table page change with parent
  useEffect(() => {
    if (pageIndex !== currentPage) {
      onPageChange?.(pageIndex);
    }
  }, [pageIndex]);

  // Handle page size change
  const handlePageSizeChange = (e) => {
    const newSize = Number(e.target.value);
    setPageSize(newSize);
    onPageSizeChange?.(newSize);
  };

  // Custom pagination items with ellipsis
  const renderPaginationItems = () => {
    const total = Math.ceil(count / pageSize);
    const maxButtons = 5;
    const items = [];

    const startPage = Math.max(0, Math.min(pageIndex - 2, total - maxButtons));
    const endPage = Math.min(total, startPage + maxButtons);

    if (startPage > 0) {
      items.push(
        <Pagination.Item key={0} onClick={() => gotoPage(0)}>
          1
        </Pagination.Item>
      );
      if (startPage > 1) items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    for (let i = startPage; i < endPage; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === pageIndex}
          onClick={() => gotoPage(i)}
          style={
            i === pageIndex
              ? { backgroundColor: "#00598d", borderColor: "#00598d", color: "#fff" }
              : {}
          }
        >
          {i + 1}
        </Pagination.Item>
      );
    }

    if (endPage < total) {
      if (endPage < total - 1)
        items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      items.push(
        <Pagination.Item key={total - 1} onClick={() => gotoPage(total - 1)}>
          {total}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div>
      <div className="custom-grid ">
        <Table
          {...getTableProps()}
          striped
          bordered
          hover
          responsive
          className="custom-grid mb-2"
        >
          <thead>
            {headerGroups.map((headerGroup, idx) => (
              <tr key={idx} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, idx) => (
                  <th
                    key={idx}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    style={{
                      width: column.width,
                      minWidth: column.minWidth || "10px",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="dark-panel">
            {page.length > 0 ? (
              page.map((row, idx) => {
                prepareRow(row);
                return (
                  <tr key={idx} {...row.getRowProps()}>
                    {row.cells.map((cell, idx) => (
                      <td key={idx} {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Sticky Pagination */}
      {count > pageSize && (
        <div
          className="dark-panel d-flex justify-content-between align-items-center flex-wrap pagination-container py-2 "
          style={{
            position: "sticky",
            bottom: 0,
            // backgroundColor: "#fff",
            border: "1px solid #dee2e6",
            boxShadow: "0 -2px 5px rgba(0,0,0,0.05)",
            zIndex: 5,
            marginRight: "25px"
          }}

        >
          <div className="d-flex align-items-center mb-2 mb-md-0">
            <span className="me-2">Show</span>
            <Form.Select
              size="sm"
              value={pageSize}
              onChange={handlePageSizeChange}
              style={{ width: "90px" }}
            >
              {[50, 100, 150, 200].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </Form.Select>
            <span className="ms-2">entries out of {count}</span>
          </div>

          <Pagination className="mb-0 ">
            <Pagination.Prev
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            >
              Previous
            </Pagination.Prev>
            {renderPaginationItems()}
            <Pagination.Next onClick={() => nextPage()} disabled={!canNextPage}>
              Next
            </Pagination.Next>
          </Pagination>
        </div>
      )}
    </div>
  );
};

CustomGrid.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      Header: PropTypes.string,
      accessor: PropTypes.string,
      Cell: PropTypes.func,
      width: PropTypes.string,
      minWidth: PropTypes.string,
    })
  ).isRequired,
  data: PropTypes.any,
  pageSize: PropTypes.number,
  count: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
};

export default CustomGrid;
